import React from 'react';
import { Card } from './ui/Card';
import { CheckCircle2, BookOpen, Users, Sparkles } from 'lucide-react';
export function ProductBreakdown() {
  return <section className="py-20 bg-gray-50" id="que-incluye" data-id="element-76">
      <div className="container mx-auto px-4" data-id="element-77">
        <div className="text-center mb-16" data-id="element-78">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4" data-id="element-79">
            ¿Qué Incluye el <span className="text-red-700" data-id="element-80">Mega Pack</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-81">
            Todo lo que necesitás para tus clases, dividido por niveles y
            objetivos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-82">
          {/* Primaria */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-amber-500" data-id="element-83">
            <div className="h-48 overflow-hidden relative group" data-id="element-84">
              <img src="https://cdn.magicpatterns.com/uploads/fc74x759wQnTi1zizsgG11/ChatGPT_Image_15_feb_2026,_09_32_32_p.m..png" alt="Teatro Primaria" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-85" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6" data-id="element-86">
                <h3 className="text-2xl font-bold text-white flex items-center gap-2" data-id="element-87">
                  <BookOpen className="w-6 h-6 text-amber-400" data-id="element-88" />
                  Nivel Primaria
                </h3>
              </div>
            </div>
            <div className="p-8 flex-1 flex flex-col" data-id="element-89">
              <p className="text-gray-600 mb-6" data-id="element-90">
                Material lúdico y estructurado para introducir a los niños en el
                mundo del teatro.
              </p>
              <ul className="space-y-3 mb-8 flex-1" data-id="element-91">
                <li className="flex items-start gap-3" data-id="element-92">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-93" />
                  <span className="text-gray-700" data-id="element-94">
                    Planificaciones semanales detalladas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-95">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-96" />
                  <span className="text-gray-700" data-id="element-97">
                    Actividades lúdicas y juegos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-98">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-99" />
                  <span className="text-gray-700" data-id="element-100">
                    Proyectos cortos de representación
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-101">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-102" />
                  <span className="text-gray-700" data-id="element-103">
                    Evaluaciones adaptadas por edad
                  </span>
                </li>
              </ul>
            </div>
          </Card>

          {/* Secundaria */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-red-600 transform md:-translate-y-4" data-id="element-104">
            <div className="h-48 overflow-hidden relative group" data-id="element-105">
              <img src="https://cdn.magicpatterns.com/uploads/uLh8TaZW4gPdyDK1juSBnM/ChatGPT_Image_15_feb_2026,_09_16_19_p.m..png" alt="Teatro Secundaria" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-106" />
              <div className="absolute top-4 right-4 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg" data-id="element-107">
                MÁS POPULAR
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6" data-id="element-108">
                <h3 className="text-2xl font-bold text-white flex items-center gap-2" data-id="element-109">
                  <Users className="w-6 h-6 text-red-400" data-id="element-110" />
                  Nivel Secundaria
                </h3>
              </div>
            </div>
            <div className="p-8 flex-1 flex flex-col bg-white" data-id="element-111">
              <p className="text-gray-600 mb-6" data-id="element-112">
                Desafíos creativos y técnicos para adolescentes, enfocados en la
                expresión y el montaje.
              </p>
              <ul className="space-y-3 mb-8 flex-1" data-id="element-113">
                <li className="flex items-start gap-3" data-id="element-114">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-115" />
                  <span className="text-gray-700" data-id="element-116">
                    Planificaciones anuales completas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-117">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-118" />
                  <span className="text-gray-700" data-id="element-119">
                    Técnicas de improvisación avanzada
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-120">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-121" />
                  <span className="text-gray-700" data-id="element-122">
                    Guías de creación de personajes
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-123">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-124" />
                  <span className="text-gray-700" data-id="element-125">
                    Proyectos de montaje final
                  </span>
                </li>
              </ul>
            </div>
          </Card>

          {/* Bonos */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-purple-600" data-id="element-126">
            <div className="h-48 overflow-hidden relative group" data-id="element-127">
              <img src="https://cdn.magicpatterns.com/uploads/7UDj9E1U6LptBiCxfFYMTv/ChatGPT_Image_15_feb_2026,_08_38_00_p.m..png" alt="Bonos Exclusivos" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-128" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6" data-id="element-129">
                <h3 className="text-2xl font-bold text-white flex items-center gap-2" data-id="element-130">
                  <Sparkles className="w-6 h-6 text-purple-400" data-id="element-131" />
                  Bonos Exclusivos
                </h3>
              </div>
            </div>
            <div className="p-8 flex-1 flex flex-col" data-id="element-132">
              <p className="text-gray-600 mb-6" data-id="element-133">
                Recursos extra para enriquecer tus clases y resolver situaciones
                imprevistas.
              </p>
              <ul className="space-y-3 mb-8 flex-1" data-id="element-134">
                <li className="flex items-start gap-3" data-id="element-135">
                  <CheckCircle2 className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-136" />
                  <span className="text-gray-700" data-id="element-137">
                    Banco de 100+ dinámicas grupales
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-138">
                  <CheckCircle2 className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-139" />
                  <span className="text-gray-700" data-id="element-140">
                    Ideas para ferias y actos escolares
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-141">
                  <CheckCircle2 className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-142" />
                  <span className="text-gray-700" data-id="element-143">
                    Kit de guiones 100% editables
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-144">
                  <CheckCircle2 className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-145" />
                  <span className="text-gray-700" data-id="element-146">
                    Planillas de seguimiento de alumnos
                  </span>
                </li>
              </ul>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}